export const DOMAIN_LOCALE: { [key: string]: string } = {
  com: 'en-US',
  ie: 'en-IE',
  uk: 'en-GB',
  localhost: 'local',
};

export const DOMAIN_TLD: { [key: string]: string } = {
  com: 'en-US',
  ie: 'en-IE',
  uk: 'en-GB',
  localhost: 'local',
};
